import { watches } from "@/definitions/diaryTypes";
import type { Watch } from "@/definitions/diaryTypes";
import { ExternalLink } from "lucide-react";
import type React from "react";
import { Button } from "../../../components/ui/button";

interface DiaryTypeLinkProps {
	diaryType: string;
}

const DiaryTypeLink: React.FC<DiaryTypeLinkProps> = ({ diaryType }) => {
	const watchType = diaryType?.toUpperCase() as Watch;
	const watch = watches[watchType];

	if (!watch) return null;

	// If there's no info link, just show the name
	if (!watch.infoLink) {
		return <h3 className="font-medium text-md text-slate-800">{watch.name}</h3>;
	}

	return (
		<Button variant="link" asChild>
			<a
				href={watch.infoLink}
				target={"_blank"}
				rel={"noopener noreferrer"}
				className="flex items-center gap-1.5 mx-auto text-muted-foreground text-primary hover:text-primary text-sm text-center hover:underline underline-offset-2 transition-colors"
				title={`Learn more about ${watch.name}`}
			>
				Learn more
				<ExternalLink size={16} />
			</a>
		</Button>
	);
};

export default DiaryTypeLink;
